<template>
  <img
    src="@/assets/icons/checkin.svg"
    @click="openCheckin()"
    v-if="!loading"
  />
  <i class="fas fa-spinner fa-spin icon" v-else></i>
</template>

<script>
import getLink from "../../services/checkin/checkin-service.js";
import { createToast } from "../../components/toast/toast";

export default {
  components: {},
  data: function() {
    return {
      loading: false,
    };
  },
  methods: {
    async openCheckin() {
      this.loading = true;
      try {
        const link = await getLink();
        window.open(link, "_blank");
      } catch (error) {
        console.error("openCheckin", error);
        createToast("Erro", "Não foi possível acessar o checkin.");
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.img-reflesh {
  &--loadind {
    animation: spin 1s linear infinite;
  }
}
</style>
